export default {
    SET_USER_LIST(state, payload){
        state.userList = payload
    },
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    }
}
